import type {
  GetReportsStartupChecklistsStatisticsApiArg,
  GetReportsStartupChecklistsStatisticsApiResponse,
} from "../../../../../openapi";

export const statisticsUrl = (origin: string, args: GetReportsStartupChecklistsStatisticsApiArg) => {
  const url = new URL("/api/trpc/reports/startup-checklists/statistics", origin);
  url.searchParams.set("projectNo", String(args.projectNo));
  if (args.subTaskNo !== undefined) url.searchParams.set("subTaskNo", args.subTaskNo);
  return url.toString();
};

// Illustrative future templates and people; never used as a fallback for failed API calls.
export const startupStatsExample: GetReportsStartupChecklistsStatisticsApiResponse = [
  {
    reportId: "000000000000000000000901",
    name: "Overlevering av oppdrag",
    templateId: 901,
    status: "ACTIVE",
    completionPercent: 75,
    createdAt: "2026-09-01T08:00:00.000Z",
    createdBy: { _id: "000000000000000000000001", name: "Demo · Anna Hansen" },
    updatedAt: "2026-09-10T09:30:00.000Z",
    lastUpdatedBy: { _id: "000000000000000000000002", name: "Demo · Erik Berg" },
  },
  {
    reportId: "000000000000000000000902",
    name: "Oppdragsplanlegging (eksempel)",
    templateId: 902,
    status: "COMPLETED",
    completionPercent: 100,
    createdAt: "2026-09-02T10:00:00.000Z",
    createdBy: { _id: "000000000000000000000002", name: "Demo · Erik Berg" },
    updatedAt: "2026-09-09T13:15:00.000Z",
    lastUpdatedBy: { _id: "000000000000000000000002", name: "Demo · Erik Berg" },
  },
  {
    reportId: "000000000000000000000903",
    name: "Kvalitet og risiko (eksempel)",
    templateId: 903,
    status: "ACTIVE",
    completionPercent: 25,
    createdAt: "2026-09-03T07:00:00.000Z",
    createdBy: { _id: "000000000000000000000001", name: "Demo · Anna Hansen" },
    updatedAt: "2026-09-08T11:45:00.000Z",
    lastUpdatedBy: { _id: "000000000000000000000001", name: "Demo · Anna Hansen" },
  },
];
